import axios from '@/libs/api.request'
import config from '@/config'

export const operationCompany = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/company/',
    method: meth,
    data
  })
}

export const getjobstypeList = (value, level) => {
  return axios.request({
    url: '/v1/scinfo/jobstypelist/',
    method: 'get',
    params: {
      value,
      level
    }
  })
}

export const changeJob = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/changeJob/',
    method: meth,
    data
  })
}

export const operationJob = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/job/',
    method: meth,
    data
  })
}

export const getjoblist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/scinfo/job/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationCompanydown = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/companydown/',
    method: meth,
    data
  })
}

export const getCompanylist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/scinfo/company/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const roomtoanother = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/room/',
    method: meth,
    data
  })
}

export const chagneroom = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/room/',
    method: meth,
    data
  })
}

export const getroomlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/scinfo/room/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const getJobfairlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/scinfo/Jobfair/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const changeJobfair = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/changeJobfair/',
    method: meth,
    data
  })
}

export const uptojobfair = (data) => {
  return axios.request({
    url: '/v1/scinfo/uptojobfair/',
    method: 'post',
    data
  })
}

export const uptotcrc = (data) => {
  return axios.request({
    url: '/v1/scinfo/uptotcrc/',
    method: 'post',
    data
  })
}

export const operationJobfair = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/Jobfair/',
    method: meth,
    data
  })
}

export const getMarketlist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/scinfo/Market/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const getoldmartetList = (key) => {
  return axios.request({
    url: '/v1/tcrc/marketlist/',
    method: 'get',
    params: {
      key
    }
  })
}

export const operationMarket = (data, meth) => {
  return axios.request({
    url: '/v1/scinfo/Market/',
    method: meth,
    data
  })
}
